import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {

  // DEVELOPMENT
  // static baseUrl = 'https://sharedservices.enstaff.org.ph/maps/cli2' // FOR GET, POST
  // static baseUrlOld = 'https://sharedservices.enstaff.org.ph/maps/cli2/v1' // FOR PUT, DELETE, RANGE, HD
  // static baseUrl2 = 'https://maps-sandbox.reallife.ph';
  // static mediaUrl = 'https://sharedservices.enstaff.org.ph/maps/cli2/uploads';
  // static email = 'https://onedb-qas.everynation.org.ph//db/module/real_life/email_maps/send_email'

  // // PRODUCTION
  static baseUrl = 'https://sharedservices.enstaff.org.ph/maps/cli'
  static baseUrlOld = 'https://sharedservices.enstaff.org.ph/maps/cli/v1'
  static baseUrl2 = 'https://maps.reallife.ph';
  static mediaUrl = 'https://sharedservices.enstaff.org.ph/maps/cli/uploads';
  static email = 'https://onedb.everynation.org.ph//db/module/real_life/email_maps/send_email'


  static EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  static PHONE_REGEX = /^(9)\d{9}$/
  constructor() { }
}
